<template>
    <div>
        <div v-for="(product, i) in products" :key="i">
            <div class="_dflex ui-program-card _flexwrap-mobile">
                <div class="ui-program-card__image">
                    <img :src="product.img" alt="program-image">
                </div>
                <div class="ui-program-card__content _pl-32-0 _pt-12-24 _pb-12-0 _dflex _flexdir-column">
                    <div class="_flex-1 _dflex _flexdir-column _overflow-hidden _justify-content-center">
                        <div class="_dflex _flexdir-column">
                            <p class="h3 _mb-8-all">{{ product.title }}</p>
                            <p class="p2">{{ product.subtitle }}</p>
                        </div>
                    </div>
                    <div class="_dflex _flexdir-column _flex-1 _justify-content-center">
                        <div class="_dflex _flexwrap-mobile">
                            <div class="_flex-auto _dgrid _mt-0-24 _mb-0-24 _pr-24-0">
                                <div class="_dflex _w-100">
                                    <div class="ui-program-card__parameter"  v-for="(fact, j) in product.facts" :key="j">
                                        <p class="text-gray p2 _mb-8-4">{{ fact.name }}</p>
                                        <p class="h3">{{ fact.value }}</p>
                                    </div>
                                </div>
                            </div>
                            <a :href="product.link" class="button button_min_w-max button_green">Подробнее</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="_bb _mt-40-32 _mb-40-32"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoansProductList',
    props: {
        products: {
            type: Array,
            default() {
                return [
                    {
                        img: '/local/templates/redesign/src/assets/img/loans/product_loan.webp',
                        title: 'Кредит наличными',
                        subtitle: 'Без залога и поручителей',
                        link: '/loans/credit/',
                        facts: [
                            {
                                name: 'Сумма',
                                value: 'до 10 млн ₽'
                            },
                            {
                                name: 'Срок',
                                value: 'до 7 лет'
                            }
                        ]
                    },
                    {
                        img: '/local/templates/redesign/src/assets/img/loans/product_refin.webp',
                        title: 'Рефинансирование кредитов',
                        subtitle: 'Комфортный платеж и дополнительная сумма на любые цели',
                        link: '/loans/refin/',
                        facts: [
                            {
                                name: 'Сумма',
                                value: 'до 10 млн ₽'
                            },
                            {
                                name: 'Срок',
                                value: 'до 7 лет'
                            }
                        ]
                    },
                    {
                        img: '/local/templates/redesign/src/assets/img/loans/product_pension.webp',
                        title: 'Кредит для пенсионеров',
                        subtitle: 'Кредит наличными на специальных условиях',
                        link: '/loans/pension/',
                        facts: [
                            {
                                name: 'Сумма',
                                value: 'до 10 млн ₽'
                            },
                            {
                                name: 'Срок',
                                value: 'до 7 лет'
                            }
                        ]
                    }
                ]
            }
        }
    }
}
</script>
